import script from "./FormularioInscripcionCard.vue?vue&type=script&setup=true&lang=js"
export * from "./FormularioInscripcionCard.vue?vue&type=script&setup=true&lang=js"

import "./FormularioInscripcionCard.vue?vue&type=style&index=0&id=22575a60&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22575a60"]])

export default __exports__